var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResize,
          expression: "onResize"
        }
      ],
      attrs: {
        icon: "mdi-information-variant",
        color: "info",
        title: _vm.property
          ? `${_vm.property.code} : ${_vm.property.name}`
          : "",
        boilerplate: ""
      },
      on: { close: _vm.handleCloseClick },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c("alert-actions", {
                attrs: { isMenu: false, hasLabel: "", alert: _vm.item }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "d-flex" }, [
        _c(
          "div",
          {
            staticClass: "d-flex mr-2 elevation-5",
            style: `width: ${_vm.sidePanelIsOpen ? "16%" : "34px"};`
          },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.sidePanelIsOpen,
                    expression: "sidePanelIsOpen"
                  }
                ],
                staticStyle: { width: "100%" }
              },
              [_c("alerts-left-side", { attrs: { height: _vm.height } })],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex align-center",
                style: { height: _vm.height + "px" }
              },
              [
                _c("div", { staticClass: "primary menu-bar" }),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "primary",
                    staticStyle: {
                      position: "relative",
                      left: "11px",
                      "z-index": "10"
                    },
                    attrs: { icon: "", small: "" },
                    on: { click: _vm.handleToggleLeftPanel }
                  },
                  [
                    _c("v-icon", { attrs: { color: "background" } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.sidePanelIsOpen
                              ? "navigate_before"
                              : "navigate_next"
                          ) +
                          "\n          "
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { style: `width: ${_vm.sidePanelIsOpen ? 84 : 100}%;` },
          [
            _c(
              "v-tabs",
              {
                attrs: {
                  "background-color":
                    _vm.$vuetify.theme.themes[_vm.theme].background,
                  height: _vm.TABS_HEIGHT
                },
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c("v-tab", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateMessage("requests.details.titles.property")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-tab",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.beginSensors || _vm.hasSensors,
                        expression: "beginSensors || hasSensors"
                      }
                    ]
                  },
                  [
                    _vm.hasUnseenErrors
                      ? _c("v-badge", { attrs: { color: "error" } }, [
                          _c(
                            "span",
                            { attrs: { slot: "badge" }, slot: "badge" },
                            [_vm._v("!")]
                          ),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.generateMessage(
                                  "requests.details.titles.sondes"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                      : _c("div", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.generateMessage(
                                  "requests.details.titles.sondes"
                                )
                              ) +
                              "\n          "
                          )
                        ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-tab", [
                  _vm._v(
                    _vm._s(_vm.generateMessage("requests.details.titles.fri"))
                  )
                ]),
                _vm._v(" "),
                _c("v-tab", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateMessage("requests.details.titles.logbook")
                      ) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _c("v-tab", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.generateMessage("requests.details.titles.documents")
                      ) +
                      "\n        "
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-tabs-items",
              {
                staticClass: "overflow-y-hidden",
                style: {
                  height: _vm.height + "px",
                  width: "100%",
                  background: _vm.$vuetify.theme.themes[_vm.theme].background,
                  "overflow-y": "auto !important"
                },
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c(
                  "v-tab-item",
                  [
                    _c(
                      "loader",
                      { attrs: { "is-loading": _vm.isLoading } },
                      [
                        _c("property-general"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex flex-wrap" },
                          [
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [_c("property-contract")],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { attrs: { cols: "12", md: "6" } },
                              [_c("property-exploitation")],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-tab-item", [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-nowrap",
                      style: { height: _vm.height - 20 + "px" }
                    },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", xl: "6" } },
                        [
                          _c("sensors-table", {
                            staticClass: "ma-2",
                            staticStyle: { width: "100%" },
                            attrs: { height: _vm.height - 170 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", xl: "6" } },
                        [
                          _c("sensors-errors-table", {
                            staticClass: "ma-2",
                            staticStyle: { width: "100%" },
                            attrs: { height: _vm.height - 170 }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("v-tab-item", [_c("summary-property-sheet")], 1),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  [
                    _c("logbook-reduced-filters", {
                      style: {
                        height: "80px"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        style: {
                          height: _vm.height - 80 + "px",
                          "overflow-y": "auto"
                        }
                      },
                      [_c("logbook")],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  [
                    _c("documents-horizontal-filters", {
                      style: {
                        height: "80px"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        style: {
                          height: _vm.height - 80 + "px",
                          "overflow-y": "auto"
                        }
                      },
                      [_c("property-documents", { attrs: { "is-modal": "" } })],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }